import React, {useEffect} from 'react';
import {Image} from "../../image/image";
import {prepareWscPlayer} from "./wsc-player";
import styles from './floating-button.wsc.module.scss';

// The floating bubble's face: the story thumbnail straight from the game feed (renders instantly,
// no Blaze dependency). Tapping the bubble opens the WSC player — wired via FloatingComponent's
// onClick. We warm the Blaze player here so the click can play inside its user-gesture.
export const WscFloatingButton = ({story, isRtl, cultureName}) => {
  useEffect(() => {
    prepareWscPlayer(story, {isRtl, cultureName});
  }, [story?.id, isRtl, cultureName]);

  return story?.thumbnail ? <Image src={story.thumbnail} className={styles.wsc_floating_button} eager={true}/> : null

};
